import { Page } from '@/core/architecture'

import { MissionAccomplishedTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * MissionAccomplished Page
 * Implemented as a practical sample.
 */
export const MissionAccomplished: Page = () => {
  const { state, actions } = useViewModel()

  return <MissionAccomplishedTemplate state={state} />
}
